"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1813],{

/***/ 72715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n\n    @keyframes spinner {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes spinnerEase {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    .loading-spinner {\n      width: inherit;\n      height: inherit;\n      border: 3px solid ",
        ";\n      border-top: 3px solid ",
        ";\n      border-radius: 50%;\n      animation: spinner 1.2s ease-in-out infinite;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Loading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "loading-spinner"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Loading__StyledWrapper",
    componentId: "sc-5bfb9b57-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.background.bg_1, theme.color.primary_2);
});


/***/ }),

/***/ 75609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ COVER_LETTER_TYPE_TEXT_OBJECT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);


var _obj;
var COVER_LETTER_TYPE_TEXT_OBJECT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.ALL */ .DJ7.ALL, "전체"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.MAJOR_COMPANY */ .DJ7.MAJOR_COMPANY, "대기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.MEDIUM_COMPANY */ .DJ7.MEDIUM_COMPANY, "중견기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.SMALL_COMPANY */ .DJ7.SMALL_COMPANY, "중소기업/스타트업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.PUBLIC_INSTITUTIONS */ .DJ7.PUBLIC_INSTITUTIONS, "공기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.BANKS */ .DJ7.BANKS, "은행권"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.ETC */ .DJ7.ETC, "기타"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.INTERN */ .DJ7.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterType.NEWCOMER */ .DJ7.NEWCOMER, "신입"), _obj);


/***/ }),

/***/ 61813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ CoverLetterList_CoverLetterListContent; },
  "AB": function() { return /* binding */ getCoverLetterItemLinkProps; },
  "vl": function() { return /* binding */ getQueryParams; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var src_context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/NotFound.tsx
var NotFound = __webpack_require__(56683);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/desktop/components/CoverLetterList/CoverLetterListItemDesktop.tsx + 2 modules
var CoverLetterListItemDesktop = __webpack_require__(95935);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/LoadingItemList.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  padding: 20px 0;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .flex-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bookmark-icon {\n    color: rgba(0, 0, 0, 0.11);\n    width: 15px;\n  }\n\n  .basic-info {\n    width: 100px;\n    margin-right: 25px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n  }\n\n  .spec-info {\n    margin-right: 3.75px;\n    margin-bottom: 0.5px;\n    width: 100%;\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  .content {\n    margin-right: 3.75px;\n    margin-bottom: 0.5px;\n    margin-top: 5px;\n    width: 100%;\n    flex-grow: 1;\n  }\n\n  .content-wrapper {\n    margin-right: 3.75px;\n    flex-grow: 1;\n    display: flex;\n    min-width: 0;\n    max-width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .scrap-icon {\n    padding: 12px 12px 15px;\n    flex-shrink: 0;\n    margin-left: 20px;\n  }\n\n  .flex-center {\n    min-width: 0;\n    align-items: center;\n    display: flex;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var LOADING_ITEM_LENGTH = 20;
var LoadingItemList = function() {
    var loadingItems = new Array(LOADING_ITEM_LENGTH).fill("");
    var columnTimes = new Array(4).fill("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loadingItems.map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-wrapper",
                        children: [
                            columnTimes.map(function(_, columnIndex) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "basic-info",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        width: 100
                                    })
                                }, columnIndex);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "spec-info",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                height: 16,
                                                width: 350
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                height: 70,
                                                width: 500
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "scrap-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* BookMark */.QC, {
                            className: "bookmark-icon"
                        })
                    })
                ]
            }, "loading-item-".concat(index));
        })
    });
};
/* harmony default export */ var components_LoadingItemList = (LoadingItemList);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoadingItemList__StyledWrapper",
    componentId: "sc-dc17ca42-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background.bg_3;
});

// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMobile.tsx + 1 modules
var CoverLetterListItemMobile = __webpack_require__(70335);
// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/LoadingItemList.tsx

function LoadingItemList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  padding: 20px 0;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .flex-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bookmark-icon {\n    color: rgba(0, 0, 0, 0.11);\n    width: 15px;\n  }\n\n  .mobile-skeleton {\n    margin-bottom: 5px;\n  }\n\n  .scrap-icon {\n    padding: 12px;\n    flex-shrink: 0;\n    margin-left: 10px;\n  }\n\n  .block-display {\n    display: block;\n  }\n"
    ]);
    LoadingItemList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var LoadingItemList_LOADING_ITEM_LENGTH = 20;
var LoadingItemList_LoadingItemList = function() {
    var loadingItems = new Array(LoadingItemList_LOADING_ITEM_LENGTH).fill("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loadingItems.map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingItemList_StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block-display",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 200,
                                    height: 20,
                                    className: "mobile-skeleton"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 250,
                                    height: 20,
                                    className: "mobile-skeleton"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 280,
                                    height: 35,
                                    className: "mobile-skeleton"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "scrap-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
                            className: "bookmark-icon"
                        })
                    })
                ]
            }, "loading-item-".concat(index));
        })
    });
};
/* harmony default export */ var mobile_components_LoadingItemList = (LoadingItemList_LoadingItemList);
var LoadingItemList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoadingItemList__StyledWrapper",
    componentId: "sc-54df9fb9-0"
})(LoadingItemList_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background.bg_3;
});

// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/useSearchState.ts
var useSearchState = __webpack_require__(70665);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/CoverLetterList/CoverLetterListContent.tsx



function CoverLetterListContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 10px;\n  .divider {\n    margin: 0;\n    border: 0.5px solid #eee;\n  }\n"
    ]);
    CoverLetterListContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterListContent_currentUser on User {\n    ...CoverLetterListItem_currentUser\n  }\n  fragment CoverLetterListContent_coverLetterElasticEdge on CoverLetterElasticEdge {\n    node {\n      id\n      ...CoverLetterListItem_coverLetter\n    }\n    highlight\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var getQueryParams = function(context) {
    var search = context.search, page = context.page, orderBy = context.orderBy;
    return query_string.stringify((0,utils/* filterEmptyField */.fW)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tab: useSearchState/* TabState.ALL */.Xh.ALL
    }, search), {
        page: page,
        sort: orderBy === null || orderBy === void 0 ? void 0 : orderBy.orderField
    })));
};
var getCoverLetterItemLinkProps = function(context, coverLetterID) {
    var queryParams = getQueryParams(context);
    return {
        href: coverLetterID ? "/cover-letter/[id]?".concat(queryParams) : "",
        as: coverLetterID ? "/cover-letter/".concat(coverLetterID, "?").concat(queryParams) : "",
        naked: true
    };
};
var CoverLetterListContent = function(param) {
    var currentUser = param.currentUser, coverLetterEdges = param.coverLetterEdges, loading = param.loading;
    var isMobile = (0,src_context/* useUA */.nD)().isMobile;
    var context = (0,useSearchState/* useSearchStateContext */.az)();
    if (loading) {
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_components_LoadingItemList, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoadingItemList, {});
    }
    if (!coverLetterEdges.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: coverLetterEdges.map(function(edge, index) {
            var coverLetter = edge.node;
            var LinkProps = getCoverLetterItemLinkProps(context, coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListItemMobile/* default */.Z, {
                        coverLetter: coverLetter,
                        coverLetterHighlight: edge.highlight,
                        currentUser: currentUser,
                        LinkProps: LinkProps
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListItemDesktop/* default */.Z, {
                        coverLetter: coverLetter,
                        coverLetterHighlight: edge.highlight,
                        currentUser: currentUser,
                        LinkProps: LinkProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListContent_StyledWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "divider"
                        })
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var CoverLetterList_CoverLetterListContent = (CoverLetterListContent);
var CoverLetterListContent_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterListContent__StyledWrapper",
    componentId: "sc-ba5a0cce-0"
})(CoverLetterListContent_templateObject());
src_default()(_templateObject1());


/***/ }),

/***/ 41678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47079);
/* harmony import */ var components_LoginAlert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39749);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96597);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: inherit;\n  font-weight: inherit;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CoverLetterScrap_currentUser on User {\n    id\n    scrapCount\n    isCheckedParagraphScrapGuide\n  }\n  fragment CoverLetterScrap_coverLetter on CoverLetter {\n    id\n    isScrapped\n    scrapCount\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CoverLetterScrap = function(props) {
    var closeLoginAlert = function closeLoginAlert() {
        setShowLoginAlert(false);
    };
    var scrapCoverLetter = function scrapCoverLetter() {
        if (!(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id)) {
            return;
        }
        if (!currentUser) {
            setShowLoginAlert(true);
            return;
        }
        coverLetterScrapUpdate({
            optimisticResponse: {
                __typename: "Mutation",
                coverLetterScrapUpdate: {
                    __typename: "CoverLetterScrapUpdatePayload",
                    userScrap: {
                        id: "optimisticResponse_ID",
                        __typename: "UserScrap",
                        user: {
                            __typename: "User",
                            id: currentUser.id,
                            scrapCount: ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.scrapCount) || 0) + ((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? -1 : 1)
                        }
                    },
                    coverLetter: {
                        id: coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id,
                        isScrapped: !(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped),
                        scrapCount: (coverLetter.scrapCount || 0) + ((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? -1 : 1),
                        __typename: "CoverLetter"
                    },
                    scrapped: !(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped)
                }
            },
            variables: {
                coverLetterScrapUpdateInput: {
                    coverLetterID: coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id,
                    referer: "/coverLetter/".concat(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.id)
                }
            }
        });
    };
    var coverLetter = props.coverLetter, currentUser = props.currentUser, children = props.children, refetchQueries = props.refetchQueries;
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().enqueueApolloError;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useCoverLetterScrapUpdateMutation */ .JsJ)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onError: enqueueApolloError
    }, refetchQueries && {
        refetchQueries: refetchQueries,
        awaitRefetchQueries: true
    })), 2), coverLetterScrapUpdate = ref1[0], loading = ref1[1].loading;
    var scrapCount = (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.scrapCount) || 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            children({
                loading: loading,
                scrapCoverLetter: scrapCoverLetter,
                scrapCount: scrapCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_LoginAlert__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        "로그인 후 ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPrimaryText, {
                            children: "스크랩이"
                        }),
                        " ",
                        "가능합니다."
                    ]
                }),
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CoverLetterScrap);
var StyledPrimaryText = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "CoverLetterScrap__StyledPrimaryText",
    componentId: "sc-67da4c92-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
});
graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject1());


/***/ }),

/***/ 56683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68250);
/* harmony import */ var _useSearchState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70665);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  padding-top: 40px;\n  border-bottom: 0.5px solid #eeeeee;\n  padding-bottom: 40px;\n\n  .notfound-title {\n    display: flex;\n    justify-content: center;\n    font-size: 20px;\n    font-weight: bold;\n    letter-spacing: -0.8px;\n    > p {\n      color: #01a0ff;\n      > span {\n        font-size: 20;\n        font-weight: 'bold';\n        letter-spacing: '-0.8px';\n        ",
        " {\n          width: 250px;\n        }\n        color: #333333;\n      }\n    }\n  }\n\n  > p {\n    margin-top: 10px;\n    font-size: 16px;\n    color: #999999;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NotFound = function() {
    var context = (0,_useSearchState__WEBPACK_IMPORTED_MODULE_3__/* .useSearchStateContext */ .az)();
    var search = context.search;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "notfound-title",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    children: [
                        search.organizationName ? "'".concat(search.organizationName, "' ") : null,
                        search.role ? "'".concat(search.role, "' ") : null,
                        search.keyword ? "'".concat(search.keyword, "'") : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: "에 대한 검색결과가 없습니다."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    "단어의 철자가 정확한지 확인하세요. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "다른 검색어를 사용해보세요. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "더 일반적인 검색어를 사용해보세요."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotFound);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "NotFound__StyledWrapper",
    componentId: "sc-a1cf0739-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_2__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 95935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoverLetterList_CoverLetterListItemDesktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/Loading/Loading.tsx
var Loading = __webpack_require__(72715);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterScrap.tsx
var CoverLetterScrap = __webpack_require__(41678);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/app.feature/coverletter/constant/index.ts
var constant = __webpack_require__(75609);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/hooks/useKeywordHighlighter.ts
var useKeywordHighlighter = __webpack_require__(17683);
// EXTERNAL MODULE: ./src/utils/coverLetter.ts
var utils_coverLetter = __webpack_require__(5126);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/useSearchState.ts
var useSearchState = __webpack_require__(70665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/CoverLetterList/CoverLetterListItemPContent.tsx




var CoverLetterListItemPContent = function(param) {
    var content = param.content, highlight = param.highlight, typographyProps = param.typographyProps;
    if (highlight && highlight.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: highlight.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread/* default */.Z)({
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, typographyProps))
                }, index);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typographyProps), {
        children: content
    }));
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemPContent = (CoverLetterListItemPContent);

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/CoverLetterList/CoverLetterListItemPC.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .flex-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .passed-at {\n    margin-left: 10px;\n    margin-right: 20px;\n    width: 100px;\n    text-align: center !important;\n  }\n\n  .coverletter-content {\n    color: #363636;\n    text-align: start;\n    min-width: 100px;\n    font-size: 16px;\n    font-weight: normal;\n    margin-bottom: 0px;\n  }\n\n  .type-text {\n    margin-right: 36px;\n    text-align: center;\n    width: 100px;\n    word-wrap: break-word;\n  }\n\n  .content-highlight {\n    & b {\n      background-color: #bbe6ff;\n    }\n  }\n\n  .organization-name,\n  .role {\n    margin-right: 20px;\n    text-align: center;\n    width: 100px;\n\n    & .highlight {\n      font-weight: 600;\n    }\n  }\n\n  .content-wrapper {\n    margin-right: 32px;\n    flex-grow: 1;\n    display: block;\n    min-width: 0;\n    max-width: calc(100% - 416px);\n    flex-direction: row;\n    letter-spacing: -0.64px;\n  }\n\n  .spec {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    line-height: 24px;\n    max-height: 24px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n  }\n\n  .ellipsis {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .content-ellipsis {\n    line-height: 24px;\n    max-height: 72px; /* 24 * 3 */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  }\n\n  .link {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterListItemPC_coverLetter on CoverLetter {\n    id\n    role\n    contentSummaryPC: content(length: 190)\n    organizationName\n    types\n    ...CoverLetterUtils_getSpecInfo_coverLetter\n    ...CoverLetterUtils_getPassedAtText_coverLetter\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var CoverLetterListItemPC = function(param) {
    var coverLetter = param.coverLetter, LinkProps = param.LinkProps, coverLetterHighlight = param.coverLetterHighlight;
    var ref;
    var search = (0,useSearchState/* useSearchStateContext */.az)().search;
    var highlightedOrgName = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName) || "-",
        keyword: search.organizationName
    });
    var highlightedRole = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role) || "-",
        keyword: search.role
    });
    var typesText = coverLetter === null || coverLetter === void 0 ? void 0 : (ref = coverLetter.types) === null || ref === void 0 ? void 0 : ref.map(function(type) {
        if (!type) {
            return "";
        }
        return "".concat(constant/* COVER_LETTER_TYPE_TEXT_OBJECT */.U[type]);
    }).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: "link"
        }, LinkProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "coverletter-content passed-at",
                        children: (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "coverletter-content ellipsis organization-name",
                        dangerouslySetInnerHTML: {
                            __html: highlightedOrgName
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "coverletter-content ellipsis role",
                        dangerouslySetInnerHTML: {
                            __html: highlightedRole
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "coverletter-content type-text",
                        children: typesText || "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "spec",
                                children: (0,utils_coverLetter/* getSpecInfo */.t)(coverLetter)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterList_CoverLetterListItemPContent, {
                                content: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.contentSummaryPC) || "",
                                highlight: coverLetterHighlight || [],
                                typographyProps: {
                                    className: "coverletter-content content-ellipsis content-highlight"
                                }
                            })
                        ]
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemPC = (CoverLetterListItemPC);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterListItemPC__StyledWrapper",
    componentId: "sc-ada100c7-0"
})(_templateObject());
src_default()(_templateObject1());

// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/desktop/components/CoverLetterList/CoverLetterListItemDesktop.tsx

function CoverLetterListItemDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .content {\n    font-size: 16px;\n    color: #999999;\n    font-weight: normal;\n    text-align: center;\n  }\n\n  .scrap {\n    text-align: center;\n    margin-right: 16px;\n    width: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .is-scrapped {\n    color: ",
        " !important;\n    font-weight: 500;\n  }\n\n  .scrap-button {\n    color: #e8e8e8;\n    padding: 12px 12px 5px;\n    background: none;\n\n    &:hover {\n      color: ",
        ";\n      background: none;\n    }\n  }\n\n  .link {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .pc-wrapper {\n    width: 100%;\n  }\n"
    ]);
    CoverLetterListItemDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoverLetterListItemDesktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterListItem_currentUser on User {\n    ...CoverLetterScrap_currentUser\n  }\n  fragment CoverLetterListItem_coverLetter on CoverLetter {\n    id\n    content\n    isScrapped\n    ...CoverLetterListItemMobile_coverLetter\n    ...CoverLetterListItemPC_coverLetter\n    ...CoverLetterScrap_coverLetter\n  }\n"
    ]);
    CoverLetterListItemDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var CoverLetterListItemDesktop = function(param) {
    var coverLetter = param.coverLetter, currentUser = param.currentUser, initScrapIcon = param.scrapIcon, _showScrapCount = param.showScrapCount, showScrapCount = _showScrapCount === void 0 ? true : _showScrapCount, scrapRefetchQueries = param.scrapRefetchQueries, coverLetterHighlight = param.coverLetterHighlight, _LinkProps = param.LinkProps, LinkProps = _LinkProps === void 0 ? {
        href: "/",
        naked: true
    } : _LinkProps;
    var scrapIcon = initScrapIcon !== null && initScrapIcon !== void 0 ? initScrapIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
        isOn: !!(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped),
        strokeType: "#666666",
        className: "is-scrapped"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterListItemDesktop_StyledWrapper, {
        className: "root flex-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pc-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterList_CoverLetterListItemPC, {
                    coverLetter: coverLetter,
                    coverLetterHighlight: coverLetterHighlight,
                    LinkProps: LinkProps
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "scrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrap/* default */.Z, {
                    coverLetter: coverLetter,
                    currentUser: currentUser,
                    refetchQueries: scrapRefetchQueries,
                    children: function(param) {
                        var scrapCoverLetter = param.scrapCoverLetter, loading = param.loading, scrapCount = param.scrapCount;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: scrapCoverLetter,
                                    className: "scrap-button",
                                    disabled: loading,
                                    children: !loading ? scrapIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                                }),
                                showScrapCount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "content ".concat((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) ? "is-scrapped" : ""),
                                    children: (scrapCount || 0) >= 1000 ? "999+" : scrapCount
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemDesktop = (CoverLetterListItemDesktop);
var CoverLetterListItemDesktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterListItemDesktop__StyledWrapper",
    componentId: "sc-7488c23a-0"
})(CoverLetterListItemDesktop_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
});
src_default()(CoverLetterListItemDesktop_templateObject1());


/***/ }),

/***/ 70335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoverLetterList_CoverLetterListItemMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.components/Loading/Loading.tsx
var Loading = __webpack_require__(72715);
// EXTERNAL MODULE: ./src/svgIcons/BookMark.tsx
var BookMark = __webpack_require__(49123);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterScrap.tsx
var CoverLetterScrap = __webpack_require__(41678);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.feature/coverletter/constant/index.ts
var constant = __webpack_require__(75609);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/hooks/useKeywordHighlighter.ts
var useKeywordHighlighter = __webpack_require__(17683);
// EXTERNAL MODULE: ./src/utils/arrayFilterJoin.ts
var arrayFilterJoin = __webpack_require__(68182);
// EXTERNAL MODULE: ./src/utils/coverLetter.ts
var utils_coverLetter = __webpack_require__(5126);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/useSearchState.ts
var useSearchState = __webpack_require__(70665);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMobileContent.tsx
var CoverLetterListItemMobileContent = __webpack_require__(30830);
;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMo.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .coverletter-mobile-content {\n    & b {\n      background-color: #bbe6ff;\n      color: #333333;\n    }\n  }\n\n  .list-item-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .content-ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    line-height: 24px;\n    max-height: 48px;\n\n    & b {\n      color: #333333;\n    }\n  }\n\n  .mobile-basic-info {\n    font-size: 16px;\n    margin-bottom: 5px;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    line-height: 24px;\n    max-height: 24px;\n\n    & .highlight {\n      font-weight: 600;\n    }\n  }\n\n  .spec-info {\n    margin-bottom: 5px;\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    line-height: 24px;\n    max-height: 24px;\n  }\n\n  .link {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterListItemMobile_coverLetter on CoverLetter {\n    id\n    role\n    contentSummaryMobile: content(length: 150)\n    organizationName\n    types\n    ...CoverLetterUtils_getSpecInfo_coverLetter\n    ...CoverLetterUtils_getPassedAtText_coverLetter\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var CoverLetterListItemMo = function(param) {
    var coverLetter = param.coverLetter, LinkProps = param.LinkProps, coverLetterHighlight = param.coverLetterHighlight;
    var ref;
    var search = (0,useSearchState/* useSearchStateContext */.az)().search;
    var highlightedOrgName = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName) || "-",
        keyword: search.organizationName
    });
    var highlightedRole = (0,useKeywordHighlighter/* default */.Z)({
        text: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role) || "-",
        keyword: search.role
    });
    var passedAt = (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter);
    var typesText = coverLetter === null || coverLetter === void 0 ? void 0 : (ref = coverLetter.types) === null || ref === void 0 ? void 0 : ref.map(function(type) {
        if (!type) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        return "".concat(constant/* COVER_LETTER_TYPE_TEXT_OBJECT */.U[type]);
    }).join(", ");
    var highlightContent = [];
    if (coverLetterHighlight && coverLetterHighlight.length > 0) {
        highlightContent.push(coverLetterHighlight[0]);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: "link"
        }, LinkProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "list-item-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mobile-basic-info",
                        dangerouslySetInnerHTML: {
                            __html: (0,arrayFilterJoin/* default */.Z)([
                                highlightedOrgName,
                                highlightedRole,
                                passedAt,
                                typesText, 
                            ])
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "spec-info",
                        children: (0,utils_coverLetter/* getSpecInfo */.t)(coverLetter)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListItemMobileContent/* default */.Z, {
                        content: (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.contentSummaryMobile) || "",
                        highlight: highlightContent,
                        typographyProps: {
                            className: "coverletter-mobile-content content-ellipsis"
                        }
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemMo = (CoverLetterListItemMo);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterListItemMo__StyledWrapper",
    componentId: "sc-c78708b2-0"
})(_templateObject());
src_default()(_templateObject1());

;// CONCATENATED MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMobile.tsx

function CoverLetterListItemMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .content {\n    font-size: 16px;\n    color: #999999;\n    font-weight: normal;\n    text-align: center;\n  }\n\n  .scrap {\n    text-align: center;\n    width: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 20px;\n    margin-right: 0;\n  }\n\n  .is-scrapped {\n    color: ",
        " !important;\n    font-weight: 500;\n  }\n\n  .scrap-button {\n    background: none;\n    padding: 12px 12px 5px 12px;\n    color: #e8e8e8;\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    > svg {\n      width: 12px;\n    }\n  }\n\n  .loading-icon {\n    height: 33px;\n    width: max-content;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .link {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    CoverLetterListItemMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CoverLetterListItemMobile = function(param) {
    var coverLetter = param.coverLetter, currentUser = param.currentUser, initScrapIcon = param.scrapIcon, _showScrapCount = param.showScrapCount, showScrapCount = _showScrapCount === void 0 ? true : _showScrapCount, scrapRefetchQueries = param.scrapRefetchQueries, coverLetterHighlight = param.coverLetterHighlight, _LinkProps = param.LinkProps, LinkProps = _LinkProps === void 0 ? {
        href: "/",
        naked: true
    } : _LinkProps;
    var scrapIcon = initScrapIcon !== null && initScrapIcon !== void 0 ? initScrapIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(BookMark/* default */.Z, {
        isOn: !!(coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped),
        strokeType: "#666666",
        className: "is-scrapped"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverLetterListItemMobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterList_CoverLetterListItemMo, {
                coverLetter: coverLetter,
                LinkProps: LinkProps,
                coverLetterHighlight: coverLetterHighlight
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "scrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrap/* default */.Z, {
                    coverLetter: coverLetter,
                    currentUser: currentUser,
                    refetchQueries: scrapRefetchQueries,
                    children: function(param) {
                        var scrapCoverLetter = param.scrapCoverLetter, loading = param.loading, scrapCount = param.scrapCount;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: scrapCoverLetter,
                                    className: "scrap-button",
                                    disabled: loading,
                                    children: scrapIcon
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "loading-icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                                }),
                                showScrapCount && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "content ".concat((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.isScrapped) && "is-scrapped"),
                                    children: (scrapCount || 0) >= 1000 ? "999+" : scrapCount
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CoverLetterList_CoverLetterListItemMobile = (CoverLetterListItemMobile);
var CoverLetterListItemMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterListItemMobile__StyledWrapper",
    componentId: "sc-e2ecea13-0"
})(CoverLetterListItemMobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary_2;
});


/***/ }),

/***/ 30830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var CoverLetterListItemMobileContent = function(param) {
    var content = param.content, highlight = param.highlight, typographyProps = param.typographyProps;
    if (highlight && highlight.length > 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: highlight.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, typographyProps))
                }, index);
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, typographyProps), {
        children: content
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CoverLetterListItemMobileContent);


/***/ }),

/***/ 70665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FB": function() { return /* binding */ filterCoverLetterSearchParams; },
/* harmony export */   "UK": function() { return /* binding */ SearchStateContextProvider; },
/* harmony export */   "Xh": function() { return /* binding */ TabState; },
/* harmony export */   "az": function() { return /* binding */ useSearchStateContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8920);
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11521);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var constants_paginations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52169);
/* harmony import */ var hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27914);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55208);










var TabState;
(function(TabState) {
    TabState["ALL"] = "all";
    TabState["MAJOR_COMPANY"] = "major_company";
    TabState["PUBLIC_INSTITUTIONS"] = "public_institutions";
    TabState["BANKS"] = "banks";
    TabState["INTERN"] = "intern";
})(TabState || (TabState = {}));
/**
 * 자소서 검색 쿼리 파라미터 필터링 함수
 * - 빈 값(null, undefined, 빈 문자열) 제거
 * - 기본값 제거: page=1, tab='all'
 */ function filterCoverLetterSearchParams(params) {
    var filtered = (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .filterEmptyField */ .fW)(params);
    // 기본값 제거
    if (filtered.page === 1) {
        delete filtered.page;
    }
    if (filtered.tab === TabState.ALL) {
        delete filtered.tab;
    }
    return filtered;
}
function initializeState(newState, updatedState) {
    if (!Object.keys(updatedState).includes("page")) {
        newState.page = 1;
    }
    if (Object.keys(updatedState).includes("tab")) {
        newState.organizationName = "";
        newState.role = "";
        newState.keyword = "";
        newState.page = 1;
    }
    return newState;
}
function useSearchState(props) {
    var handleSearchStateChange = function handleSearchStateChange(updatedState) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, searchState, query_string__WEBPACK_IMPORTED_MODULE_0__.parse(window.location.search), updatedState);
        newState = initializeState(newState, updatedState);
        newState = (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseValues */ .c6)(newState, {
            parseNumbers: true
        });
        if (onSearchStateChange) {
            onSearchStateChange(newState);
        }
    };
    var setTabState = function setTabState(newTabState) {
        handleSearchStateChange({
            tab: newTabState
        });
    };
    var setOrderBy = function setOrderBy(orderField) {
        handleSearchStateChange({
            sort: orderField
        });
    };
    var setActivePage = function setActivePage(newActivePage) {
        handleSearchStateChange({
            page: newActivePage
        });
    };
    var ref = props || {}, searchState = ref.searchState, onSearchStateChange = ref.onSearchStateChange, paginationMaxButtons = ref.paginationMaxButtons;
    var ref1 = searchState || {}, organizationName = ref1.organizationName, role = ref1.role, keyword = ref1.keyword;
    var isAfterSearch = !!organizationName || !!role || !!keyword;
    var defaultOrderBy = isAfterSearch ? generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .CoverLetterOrderField.RELEVANCE */ .lNF.RELEVANCE : generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .CoverLetterOrderField.RECENT_SCRAP_COUNT */ .lNF.RECENT_SCRAP_COUNT;
    var theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isXSDown = (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.down("xs"));
    var pagination = (0,hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        activePage: (searchState === null || searchState === void 0 ? void 0 : searchState.page) || 1,
        setActivePage: setActivePage,
        maxButtons: paginationMaxButtons || (isXSDown ? constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .MOBILE_BUTTON_SIZE */ .zw : constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .PC_BUTTON_SIZE */ .lW)
    });
    return {
        isAfterSearch: isAfterSearch,
        tabState: (searchState === null || searchState === void 0 ? void 0 : searchState.tab) || TabState.ALL,
        orderBy: {
            orderField: (searchState === null || searchState === void 0 ? void 0 : searchState.sort) || defaultOrderBy,
            orderDirection: (searchState === null || searchState === void 0 ? void 0 : searchState.direction) || generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .OrderDirection.DESC */ .N9t.DESC
        },
        search: {
            organizationName: organizationName,
            role: role,
            keyword: keyword
        },
        page: (searchState === null || searchState === void 0 ? void 0 : searchState.page) || 1,
        pagination: pagination,
        setTabState: setTabState,
        setOrderBy: setOrderBy
    };
}
var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,constate__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(useSearchState), 2);
var SearchStateContextProvider = ref[0], useSearchStateContext = ref[1];


/***/ }),

/***/ 68182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55208);

function arrayFilterJoin(arr, options) {
    var ref = options || {}, _separator = ref.separator, separator = _separator === void 0 ? " / " : _separator, _filter = ref.filter, filter = _filter === void 0 ? _utils__WEBPACK_IMPORTED_MODULE_0__/* .filterArrayEmpty */ .g2 : _filter;
    return filter(arr).join(separator);
}
/* harmony default export */ __webpack_exports__["Z"] = (arrayFilterJoin);


/***/ }),

/***/ 5126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getPassedAtText; },
/* harmony export */   "t": function() { return /* binding */ getSpecInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var date_fns_getMonth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78966);
/* harmony import */ var date_fns_getYear__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95570);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55208);
// TODO import from @apollo/client all graphql-tag

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CoverLetterUtils_getSpecInfo_coverLetter on CoverLetter {\n    university\n    major\n    grades\n    languageScore\n    career\n    activity\n    license\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CoverLetterUtils_getPassedAtText_coverLetter on CoverLetter {\n    passedAt\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var getSpecInfo = function(coverLetter) {
    return (0,utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .filterArrayEmpty */ .g2)([
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.university,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.major,
        (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.grades) && "학점 " + (coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.grades),
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.languageScore,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.career,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.activity,
        coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.license, 
    ]).join(" / ");
};
graphql_tag__WEBPACK_IMPORTED_MODULE_1___default()(_templateObject());
var getPassedAtText = function(coverLetter) {
    var ref;
    var passedAt = (ref = coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.passedAt) !== null && ref !== void 0 ? ref : 0;
    return "".concat((0,date_fns_getYear__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(passedAt), " ").concat((0,date_fns_getMonth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(passedAt) >= 1 && (0,date_fns_getMonth__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(passedAt) <= 6 ? "상반기" : "하반기");
};
graphql_tag__WEBPACK_IMPORTED_MODULE_1___default()(_templateObject1());


/***/ })

}]);